import { render, staticRenderFns } from "./Segmentation.vue?vue&type=template&id=62d8e356&scoped=true"
import script from "./Segmentation.vue?vue&type=script&lang=js"
export * from "./Segmentation.vue?vue&type=script&lang=js"
import style0 from "./Segmentation.vue?vue&type=style&index=0&id=62d8e356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d8e356",
  null
  
)

export default component.exports